export const behaviorTypeOptions = [
  { value: 'WALK_AND_WAIT', label: 'הליכה והמתנה' },
  { value: 'QUEUE_BASED', label: 'מבוסס תור' },
  { value: 'SEATED', label: 'ישיבה במקום' },
  { value: 'PASS_THROUGH', label: 'מעבר מהיר' },
  { value: 'UNKNOWN', label: 'לא ידוע' },
];
